module.exports = __webpack_public_path__ + "static/media/spinner.81fd4ccd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Global/Spinner/spinner.svg
// module id = 781
// module chunks = 0